import type { INodeConfigProps } from './index';

/**
 * `passthrough` nodes echo their input to their output — no config is
 * possible (the runtime schema is `z.object({}).optional().default({})`).
 * Renders an explanatory note so users land on the inspector and
 * understand why there's nothing to edit, rather than seeing an empty
 * panel and assuming the form failed to load.
 */
export function PassthroughConfig(_props: INodeConfigProps) {
  return (
    <p className="t-secondary t-sm" style={{ margin: 0, padding: 'var(--sp-2) 0' }}>
      Passthrough nodes have no configuration. They echo their input to their output and serve as a
      graph anchor or value pin.
    </p>
  );
}
